import { render, staticRenderFns } from "./OrderHistoryTab.vue?vue&type=template&id=21db0454"
import script from "./OrderHistoryTab.ts?vue&type=script&lang=ts&external"
export * from "./OrderHistoryTab.ts?vue&type=script&lang=ts&external"
import style0 from "./OrderHistoryTab.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports